// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"6d5f5e18","424":"9487c0fa","505":"5b5792a6","678":"923f8343","892":"913982e1","929":"be8a8d77"}[chunkId] + ".chunk.css";
};